<template>
  <div class="flex">
    <div class="w-8 flex-shrink-0 text-left text-sm font-bold text-dark-blue">
      <span
        v-if="question?.question_label"
        class="relative -left-2 whitespace-nowrap"
        :style="
          question?.is_html_subject == true &&
          question?.child_questions?.some((el) =>
            ['radio', 'checkbox', 'select'].includes(el.is_type)
          )
            ? 'top: 4.5px'
            : 'top: 0.5px'
        "
        >{{ question?.question_label }}.</span
      >
    </div>
    <div
      v-if="
        question?.is_type?.length > 0 && !question?.is_type?.includes('group')
      "
      class="w-full"
    >
      <component
        :is="componentByType[type]"
        v-show="!hidden.includes(question_id)"
        :question="question"
        :subject="subject"
        :question_id="question_id"
        :current-tax-form-id="currentTaxFormId"
        :onboarding-packet-id="onboardingPacketId"
        :set-tax-answers="setTaxAnswers"
        :toggle-required="toggleRequired"
        :required="required"
        :conditional_children="children"
        :current-answer-object="currentAnswerObject"
        @child-check="checkShowChild"
      >
        <div>
          <tax-tool-tip
            v-if="question.tooltip"
            color-scheme="light"
            :content="question.tooltip"
            class="relative"
            style="top: 1.5px"
          >
            <div class="tooltipStyle">
              <div v-html="question.tooltip" />
              <div
                v-if="question?.instructions_link"
                class="mt-1 block text-right font-semibold text-dark-blue underline"
              >
                <a
                  :href="question.instructions_link"
                  target="_blank"
                  >Learn More</a
                >
              </div>
            </div>
          </tax-tool-tip>
        </div>
      </component>
    </div>
    <div
      v-else
      class="mb-4 w-full"
    >
      <div
        v-if="
          question?.show_subject !== false && question?.is_html_subject == false
        "
        class="flex items-start"
      >
        <p class="mb-1.5 text-dark-blue">
          {{ subject?.replaceAll('%3B', ';') }}
        </p>
        <tax-tool-tip
          v-if="question.tooltip"
          color-scheme="light"
          :content="question.tooltip"
          class="relative"
          style="top: 1.5px"
        >
          <div class="tooltipStyle">
            <div v-html="question.tooltip" />
            <div
              v-if="question?.instructions_link"
              class="mt-1 block text-right font-semibold text-dark-blue underline"
            >
              <a
                :href="question.instructions_link"
                target="_blank"
                >Learn More</a
              >
            </div>
          </div>
        </tax-tool-tip>
      </div>
      <div
        v-else-if="question?.is_html_subject == true && processedHtml"
        class="mb-4 text-sm"
      >
        <!-- <component v-bind:is="processedHtml"></component> -->
        <component
          :is="dynamicComponentByType[dynamicComponentType]"
          :processed-html="processedHtml"
        />
        <!-- <processed-html v-if="dynamicComponentType == 'html'" :processedHtml="processedHtml"></processed-html> -->
        <!-- <component v-bind="{ ...this.processedHtml, is: null }"></component> -->
        <!-- <component
          v-bind="(({ is, ...processedHtml }) => processedHtml)(componentOptions)"
          :is="null">
        </component> -->
      </div>
      <p
        v-if="question?.description && !question?.is_html_description"
        class="mb-4 text-xxs font-bold uppercase text-gray-over-dark"
      >
        {{ question.description }}
      </p>
      <div
        v-else-if="question?.description && question?.is_html_description"
        class="tax-description-html mb-4 text-xxs font-bold uppercase text-gray-over-dark"
      >
        <div v-html="question.description" />
      </div>

      <div v-if="question?.is_type !== 'group_input_grid'">
        <div
          v-for="(child, index) in question.child_questions"
          :key="index"
          class="w-full"
        >
          <dynamic-tax-question-form-group
            v-show="child?.is_active"
            :item="child"
            :toggle-required="toggleRequired"
            :hidden="hidden"
            :current-tax-form-id="currentTaxFormId"
            :onboarding-packet-id="onboardingPacketId"
            :current-answer-object="currentAnswerObject"
            @hide="hideHidden"
            @unhide="unhideHidden"
            @child-check="checkShowChild"
            @group-check2="checkGroup"
          />
        </div>
      </div>
      <div
        v-else
        class="grid grid-cols-3 gap-x-2"
      >
        <div
          v-for="(child, index) in question.child_questions"
          :key="index"
          class="w-full"
        >
          <dynamic-tax-question-form-group
            :item="child"
            :toggle-required="toggleRequired"
            :hidden="hidden"
            :current-tax-form-id="currentTaxFormId"
            :onboarding-packet-id="onboardingPacketId"
            :current-answer-object="currentAnswerObject"
            @hide="hideHidden"
            @unhide="unhideHidden"
            @child-check="checkShowChild"
            @group-check2="checkGroup"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shallowRef } from 'vue';

import TaxToolTip from '@/components/TaxToolTip.vue';
import TextArea from './Type/TextArea.vue';
import Radio from './Type/Radio.vue';
import Checkbox from './Type/Checkbox.vue';
import Input from './Type/Input.vue';
import TextInput from './Type/TextInput.vue';
import Select from './Type/Select.vue';
import Date from './Type/Date.vue';
import File from './Type/File.vue';
import DynamicTaxQuestionFormGroup from './Type/DynamicTaxQuestionFormGroup.vue';
import ProcessedHtml from './Type/ProcessedHtml.vue';

const textAreaRef = shallowRef(TextArea);
const radioRef = shallowRef(Radio);
const checkboxRef = shallowRef(Checkbox);
const inputRef = shallowRef(Input);
const textInputRef = shallowRef(TextInput);
const selectRef = shallowRef(Select);
const dateRef = shallowRef(Date);
const fileRef = shallowRef(File);
const processedHtmlRef = shallowRef(ProcessedHtml);

import dayjs from 'dayjs';
import Compare from 'expr-eval';
const Parser = Compare.Parser;

export default {
  name: 'DynamicTaxQuestionForm',
  components: {
    TaxToolTip,
    DynamicTaxQuestionFormGroup,
  },
  props: {
    item: Object,
    toggleRequired: Function,
    hidden: Array,
    hideHidden: Function,
    unhideHidden: Function,
    currentAnswerObject: {
      type: [Object, Boolean],
      required: false,
      default: false,
    },
  },
  emits: ['hide', 'unhide'],
  data() {
    return {
      answer: '',
      question: '',
      id: null,
      question_id: null,
      required: null,
      type: null,
      onboardingPacketId: null,
      componentByType: {
        input_string: textInputRef,
        textarea: textAreaRef,
        radio: radioRef,
        checkbox: checkboxRef,
        input_integer: inputRef,
        input_float: inputRef,
        input_date: dateRef,
        select: selectRef,
        file: fileRef,
        file_multiple: fileRef,
      },
      parents: [],
      children: [],
      child_question_values: {},
      dynamic_subject: this.question?.subject,
      checkmark:
        '<svg width="20" height="20" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 34.25C26.6985 34.25 33.75 27.1985 33.75 18.5C33.75 15.985 33.1605 13.6076 32.1121 11.4986L18.5493 25.0614L16.9583 26.6524L15.3673 25.0614L8.43733 18.1315L11.6193 14.9495L16.9583 20.2885L29.5041 7.74266C26.6299 4.67022 22.5392 2.75 18 2.75C9.30152 2.75 2.25 9.80152 2.25 18.5C2.25 27.1985 9.30152 34.25 18 34.25Z" fill="#F8C617"/></svg>',
      dynamicComponentByType: {
        html: processedHtmlRef,
        div: undefined,
      },
    };
  },
  computed: {
    dynamicComponentType() {
      return this.processedHtml ? 'html' : 'div';
    },
    subject() {
      return this.question?.subject + (this.required ? ' (Required)' : '');
    },
    currentTaxFormId() {
      return this.$store.state.taxQuestions.current_tax_form_id;
    },
    child_question_ids() {
      let ids = [];
      if (this.question?.child_questions?.length > 0) {
        this.question.child_questions.forEach((child) => {
          ids.push(child?.id);
        });
      }
      return ids;
    },
    processedHtml() {
      let self = this;
      let returnedSubject = this.question?.subject;
      if (this.question?.child_questions?.length > 0) {
        this.question.child_questions.forEach((child, index) => {
          let idx = index + 1;
          if (child?.is_type == 'radio') {
            let optionCount = child?.options?.length;
            let val = self.child_question_values?.[child?.id]
              ? self.child_question_values?.[child?.id]
              : '';
            if (optionCount > 0) {
              for (let i = 1; i <= optionCount; i++) {
                let option = child.options.filter((o) => o.order == i);
                let newVal = option?.[0]?.id == val ? self.checkmark : '';
                let borderColor = 'border-yellow-500';
                if (newVal == '') {
                  borderColor = 'border-placeholder-gray';
                }
                returnedSubject = returnedSubject.replace(
                  '${child_' + idx + '_' + i + '}',
                  '<div class="inline-flex mr-0.5 border ' +
                    borderColor +
                    ' rounded-full h-5 w-5 relative top-1 justify-center cursor-not-allowed"><span class="relative -top-px">' +
                    newVal +
                    '</span></div>'
                );
              }
            }
          } else if (child?.is_type == 'checkbox') {
            let optionCount = child?.options?.length;
            let val = self.child_question_values?.[child?.id]
              ? self.child_question_values?.[child?.id]
              : '';
            if (optionCount > 1) {
              for (let i = 1; i <= optionCount; i++) {
                let option = child.options.filter((o) => o.order == i);
                let newVal = option?.[0]?.id == val ? self.checkmark : '';
                let borderColor = 'border-yellow-500';
                if (newVal == '') {
                  borderColor = 'border-placeholder-gray';
                }
                returnedSubject = returnedSubject.replace(
                  '${child_' + idx + '_' + i + '}',
                  '<div class="inline-flex mr-0.5 border ' +
                    borderColor +
                    ' rounded-full h-5 w-5 relative top-1 justify-center cursor-not-allowed"><span class="relative -top-px">' +
                    newVal +
                    '</span></div>'
                );
              }
            } else if (optionCount == 1) {
              for (let i = 1; i <= optionCount; i++) {
                let option = child.options.filter((o) => o.order == i);
                let newVal = option?.[0]?.id == val ? self.checkmark : '';
                let borderColor = 'border-yellow-500';
                if (newVal == '') {
                  borderColor = 'border-placeholder-gray';
                }
                returnedSubject = returnedSubject.replace(
                  '${child_' + idx + '}',
                  '<div class="inline-flex mr-0.5 border ' +
                    borderColor +
                    ' rounded-full h-5 w-5 relative top-1 justify-center cursor-not-allowed"><span class="relative -top-px">' +
                    newVal +
                    '</span></div>'
                );
              }
            }
          } else {
            let val = self.child_question_values?.[child?.id]
              ? self.child_question_values?.[child?.id]
              : '';
            if (val?.length > 5 && child?.is_type == 'input_date') {
              val = dayjs(val).format('MM-DD-YYYY');
            }
            returnedSubject = returnedSubject?.replaceAll(
              '${child_' + idx + '}',
              '<div class="inline-flex px-3 mr-0.5 border-b border-dark-gray h-4 relative top-0.5 justify-center bg-off-white cursor-not-allowed" style="min-width: 77px;"><span class="font-bold relative bottom-0.5">' +
                val +
                '</span></div>'
            );
          }
        });
      }
      returnedSubject = returnedSubject?.replaceAll('%3B', ';');
      // let comp = {
      //     template: '<div>' + returnedSubject + '</div>',
      //     is: null
      // }
      // return shallowRef(comp);
      return returnedSubject;
    },
  },
  watch: {
    item() {
      this.setQuestionData();
    },
  },
  mounted() {
    this.setQuestionData();
  },
  methods: {
    setQuestionData() {
      var self = this;
      let question = this.item;
      this.id = question?.id;
      this.required = question?.is_required;
      this.question = question;
      this.question_id = question?.id;
      this.type = question?.is_type;
      this.onboardingPacketId =
        this.$store.state.onboardingPacket.onboarding_id;
      this.parents = question?.tax_question_conditions?.parents || [];
      this.children = question?.tax_question_conditions?.children || [];
      if (question?.child_questions?.length > 0) {
        question.child_questions.forEach((child) => {
          self.child_question_values[child.id] = '';
        });
      }
    },
    async setTaxAnswers(body) {
      let currentAnswers = this.$store.state.taxQuestions.tax_answers;
      let updatedAnswers = [body];
      if (currentAnswers) {
        let filteredAnswers = currentAnswers.filter(
          (el) => el?.tax_question_id !== this.question_id
        );
        if (body) {
          updatedAnswers = [...updatedAnswers, ...filteredAnswers];
        } else {
          updatedAnswers = [...filteredAnswers];
        }
      }
      await this.$store.commit('taxQuestions/setTaxAnswers', updatedAnswers);
    },
    checkShowChild(
      question_id,
      answer,
      predicate,
      is_shown_by_default,
      is_required
    ) {
      if (this.child_question_ids?.includes(question_id)) {
        this.child_question_values[question_id] = answer;
      }
      const parser = new Parser();
      let expr = parser.parse(predicate);
      let result = expr.evaluate({ value: answer });
      if (result == true && this.hidden.includes(question_id)) {
        this.$emit('unhide', question_id);
      } else if (result == false && !this.hidden.includes(question_id)) {
        this.$emit('hide', question_id, is_shown_by_default, is_required);
      }
    },
    checkGroup(question_id, group_parent_id, answer) {
      if (
        this.question?.id == group_parent_id &&
        this.child_question_values?.[question_id] !== undefined
      ) {
        this.child_question_values[question_id] = answer;
      }
    },
  },
};
</script>

<style>
.tooltipStyle * {
  font-size: 0.6rem !important;
}
.tooltipStyle a {
  font-weight: 600 !important;
  text-decoration: underline;
}
.tooltipStyle p {
  margin-bottom: 0.5rem;
}
.tooltipStyle img {
  display: none !important;
}
</style>
